import React from 'react';

export default function Nerdy(props) {
    const { boilVolume, mashTemp, mashDuration, twist, fermentationTemp } = props;
    return (
        <section>
            <div className="px-3">
                <details>

                    <summary className="py-3 mb-3"><h4 className="d-inline-block m-0">Nerdy Stuff:</h4></summary>
                    <h5>Boil Volumne:</h5>
                    <p className="p-3 m-0">Boil Volume: {boilVolume.value} {boilVolume.unit}</p>

                    {mashTemp.value && <div>
                        <h5>Mash:</h5>
                        <div className="p-3">
                            <p>Temperature: {mashTemp.value} {mashTemp.unit}</p>
                            {mashDuration && <p className="m-0">Duration: {mashDuration} Minutes</p>}
                        </div>

                    </div>}
                    <h5>Fermintation:</h5>
                    <div className="p-3">
                        <p className="m-0">Temperature: {fermentationTemp.value} {fermentationTemp.unit}</p>
                    </div>


                    {twist &&
                        <div>
                            <h5>Special Twist:</h5>
                            <p className="m-0 p-3">{twist}</p>
                        </div>
                    }
                </details>
            </div>
        </section>
    )
}